/** @format */

export * from './shared-product-availability.module';
